const setCategory = (type) => {
	if (type) {
		document.querySelector('.content-wrapper').classList.remove('-all');
		document.querySelector('.content-wrapper').classList.add(`-${type}`);
	}
};

export default setCategory;



// WEBPACK FOOTER //
// ./src/js/promotion/setCategory.js